import { useHistory } from 'react-router-dom';
import { APP_URL } from '../constants/common';

export const useDeposit = () => {
	const history = useHistory();
	const openDepositPanel = () => {
		history.push({
			pathname: APP_URL.deposit,
		});
	};
	return {
		openDepositPanel,
	};
};
